import React, { useEffect, useState } from 'react'
import Accordion from '../../../../components/accordion/Accordion'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import commonStyles from "../ManageForms.styles"
import Button from '../../../../components/button/Button';
import RichGrid from '../../../../components/richgrid/RichGrid';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import { componentKey, setBlockStateFilingModal, setClickedActionButtonIndex, setDownloadAllPdfModal, setPaginationState, setSelectedStateForms, setSelectedStateFormsStates, setDownloadStatePdfCheckboxStates, setPayerDropdownPagination } from './ManageStateFormsSlice';
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants';
import Label from '../../../../components/label/Label';
import { LABEL_WEIGHT } from '../../../../components/label/constants';
import { blockStateFiling, downLoadStatePDFs, getStateExcelExport, getStateFilingGridData, getStateForms, getStatePDF } from './ManageStateFormsSaga';
import DownloadAllPdf from './downloadallpdf/DownloadAllPdf';
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown';
import { EDIT_FORM_ORIGIN } from '../../constants';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';
import General from '../../../../../libs/utility/General';
import { MANAGE_STATE_FORMS_LOADING_STATES, MANAGE_STATE_FORMS_LOADING_STATES_MESSAGE_MAP, TAB_PATHS } from '../constants';
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN';
import Loadable from '../../../../components/loadable/Loadable';

const ManageStateForms = ({ statePayers, stateTaxYear }) => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const navigate = useTxNavigate()

    const { formatTIN } = useFormatTIN()

    const [queryParams, setQueryParams] = useTxSearchParams();

    const { globalFormsNYearsList } = useSelector(state => state[dataLoaderKey]);

    const { loadingState, paginationState, selectedStateForms, stateFormStates, stateFilingGridData, downloadAllPdfModal, blockStateFilingModal, blockStateFilingData, clickedActionButtonIndex, stateForms, downloadStatePdfCheckboxStates, payerDropdownPagination } = useSelector(state => state[componentKey]);

    const { StateFormName, StatePayer, StateTaxYear } = stateFormStates;

    const onChangeDownloadPdfCheckboxCb = (e) => {
        const { name, checked } = e.target
        dispatch(setDownloadStatePdfCheckboxStates({ [name]: checked }))
    }

    const [paginatedPayerList, setPaginatedPayerList] = useState([]);
    useEffect(() => {
        setPaginatedPayerList(statePayers)
    }, [statePayers])

    useEffect(() => {
        const urlFormId = queryParams.get("FormId")
        dispatch(getStateForms({ urlFormId }));
    }, []);

    useEffect(() => {
        const urlTaxYear = queryParams.get("TaxYear");
        const urlPayerId = queryParams.get("PayerId");

        if (urlTaxYear) {
            const taxYear = stateTaxYear.find(year => year?.value == urlTaxYear);
            if (taxYear) {
                dispatch(setSelectedStateFormsStates({ name: "StateTaxYear", value: taxYear }))
            }
        }

        if (urlPayerId) {
            const payer = statePayers.find(payer => payer?.value == urlPayerId);
            if (payer) {
                dispatch(setSelectedStateFormsStates({ name: "StatePayer", value: payer }))
            }
        }

    }, [statePayers, stateTaxYear])

    useEffect(() => {
        if (StateFormName?.label !== "" && StatePayer?.value !== "" && StateTaxYear?.value !== "") {
            dispatch(getStateFilingGridData({ formName: StateFormName?.label, payerId: StatePayer?.value, taxYear: StateTaxYear?.value, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize }))
        }
    }, [stateFormStates, paginationState.PageNumber, paginationState.PageSize]);

    const MANAGE_STATE_FORMS_COLUMN = [
        {
            field: "StateReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>State Reference No.</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row.StateReferenceNumber}</span>
        },
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Reference No.</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row.ReferenceNumber}</span>
        },
        {
            field: "RecipientName",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.PayeeName}</span>
        },
        {
            field: "TaxId",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row?.TINType, row?.TIN)}</span>
        },
        {
            field: "Status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.Status}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>State</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.State}</span>
        },
        {
            field: "PayerStateIDTIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer State ID/TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StateAccountId || "-"}</span>
        },
        {
            field: "StateConfirmationId",
            header: <Label weight={LABEL_WEIGHT[700]}>State Confirmation ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StateReferenceNumber || "-"}</span>
        },
        {
            field: "action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => {
                const ACTIONS_MENU_OPTIONS = [
                    {
                        itemName: "View PDF",
                        onClick: () => {
                            dispatch(getStatePDF({ reconFormId: row.FormId, formName: StateFormName?.label }))
                        },
                        styles: commonStyles.prmiaryText,
                    },
                    {
                        itemName: "Edit",
                        onClick: row.ScheduledDate && (() => {
                            const queryObj = {
                                FormName: globalFormsNYearsList.Forms[StateFormName?.FormId]?.FormId,
                                Year: StateTaxYear?.value,
                                FormRecordId: row.FormId,
                                page: "ManageStateForms",
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: TAB_PATHS.STATE_FORMS,
                                })
                            }

                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/forms/createnew?${queryParamsStr}`)
                        }),
                        styles: !row.ScheduledDate ? commonStyles.disabledMenuItem : commonStyles.prmiaryText,
                    },
                    {
                        itemName: "Block",
                        onClick: row?.ScheduledDate && (() => {
                            dispatch(setClickedActionButtonIndex(idx))
                            dispatch(setBlockStateFilingModal(true))
                        }),
                        styles: !row?.ScheduledDate ? commonStyles.disabledMenuItem : commonStyles.prmiaryText,
                    },
                ]

                return <div style={commonStyles.actionButtons}>
                    <IconDropdown
                        iconName={VEC_ICON_NAME.THREE_DOT_MENU_ICON}
                        showToggle={false}
                        label=""
                        dropdownItems={ACTIONS_MENU_OPTIONS}
                        dropdownMenuStyle={commonStyles.menuItemsDropdown}
                    />
                </div>
            }
        },
    ];

    const Body = (
        <div>
            <div style={commonStyles.selectDropdown}>
                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_STATE_FORMS_LOADING_STATES.STATE_FORMS_LOADING]} messageMap={MANAGE_STATE_FORMS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                    <SelectDropdown
                        name="StateFormName"
                        label="Form Name *"
                        placeHolder="Select form"
                        options={stateForms}
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedStateFormsStates({ name: [name], value: selectedOption }));

                            if (selectedOption?.value) {
                                queryParams.set("FormId", selectedOption?.value)
                            } else {
                                queryParams.delete("FormId")
                            }
                            setQueryParams(queryParams);
                            dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                        }}
                        value={StateFormName}
                    />
                </Loadable>
                <SelectDropdown
                    name="StateTaxYear"
                    label="Tax Year *"
                    placeHolder="Select tax year"
                    options={stateTaxYear}
                    onSelectCb={(name, selectedOption) => {
                        dispatch(setSelectedStateFormsStates({ name: [name], value: selectedOption }));

                        if (selectedOption?.value) {
                            queryParams.set("TaxYear", selectedOption?.value)
                        } else {
                            queryParams.delete("TaxYear")
                        }
                        setQueryParams(queryParams);
                        dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                    }}
                    value={StateTaxYear}
                />
                <SelectDropdown
                    label="Payer *"
                    name="StatePayer"
                    placeHolder="Select a payer"
                    options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                    onDropdownTouchedToBottomCb={() => {
                        if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                            dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                        }
                    }}
                    onSelectCb={(name, selectedOption) => {
                        dispatch(setSelectedStateFormsStates({ name: [name], value: selectedOption }));

                        if (selectedOption?.value) {
                            queryParams.set("PayerId", selectedOption?.value)
                        } else {
                            queryParams.delete("PayerId")
                        }
                        setQueryParams(queryParams);
                        dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                    }}
                    value={StatePayer}
                />
            </div>

            {StateFormName?.label && StatePayer?.value && StateTaxYear?.value && <div style={commonStyles.buttonContainer}>
                <Button style={commonStyles.button} onClickCb={() => dispatch(setDownloadAllPdfModal(true))}>Download All PDFs</Button>
                <Button style={commonStyles.button} onClickCb={() => dispatch(getStateExcelExport({ formName: StateFormName?.label, payer: StatePayer?.value, taxYear: StateTaxYear?.value, }))}>Export To Excel</Button>
            </div>}
            <Loadable currentState={loadingState.state} loadingStates={[MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING]} messageMap={MANAGE_STATE_FORMS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}  >
                <div>
                    <RichGrid
                        selectable={true}
                        data={stateFilingGridData}
                        columns={MANAGE_STATE_FORMS_COLUMN}
                        extractRowKey={(row) => row.ReferenceNumber}
                        selectedRows={selectedStateForms}
                        onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStateForms(selectedData))}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStateForms(selectedData))}
                        paginationProps={{
                            skip: paginationState?.Skip,
                            take: paginationState?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState?.totalRecipients,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}
                    />
                </div>
            </Loadable>

            {downloadAllPdfModal && <DownloadAllPdf
                title="Download All PDFs"
                isPopupOpen={downloadAllPdfModal}
                onCloseCb={() => dispatch(setDownloadAllPdfModal(false))}
                onSubmitCb={(selectedOption) => dispatch(downLoadStatePDFs({ payerName: StatePayer?.LastName, formName: StateFormName?.FormName1, stateName: selectedOption?.value, taxYear: StateTaxYear?.value, payerId: StatePayer?.PayerDetailId, isRejected: false, mergeCopies: downloadStatePdfCheckboxStates.mergeCopies }))}
                options={Array.from(new Set(stateFilingGridData.map(data => data?.State))).map(state => ({
                    label: state,
                    value: state
                }))}
                checkboxValues={downloadStatePdfCheckboxStates}
                onChangeCheckBoxCb={onChangeDownloadPdfCheckboxCb}
            />}

            {blockStateFilingModal && <ConfirmationPopup
                title='Are you sure?'
                bodyText={`Are you sure you want to block ${stateFilingGridData[clickedActionButtonIndex].State} state filing?`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={blockStateFilingModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setBlockStateFilingModal(false))
                        dispatch(blockStateFiling({ reconFormId: stateFilingGridData[clickedActionButtonIndex].StateReferenceNumber, formName: StateFormName?.label, reconState: stateFilingGridData[clickedActionButtonIndex].State }))
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setBlockStateFilingModal(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />}
        </div>
    )
    return (
        <div>
            <Accordion header={'Form 1099-MISC/W-2/1099-K/1099-NEC/1099-B/1099-R'} body={Body} active={true} />
        </div>
    )
}

export default ManageStateForms